import React, {useEffect,useRef} from "react";
import { useNavigate } from "react-router-dom";
import Pencil from "../../../../images/pencil.png";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import { mapToOption } from "../../../../utlis";
import { useVendorForm } from "./../VendorFormContext";

const options = [
  { value: "", text: "--Choose an option--" },
  { value: "option1", text: "option1" },
  { value: "option2", text: "option2" },
  { value: "option3", text: "option3" },
  { value: "option4", text: "option4" },
  { value: "option5", text: "option5" },
];

const CompanyProfile = () => {
  const navigate = useNavigate();
  const { formData, updateFormData, isCreating, isSaving, markTabComplete, saveVendorData, saveAllChanges, hasUnsavedChanges } = useVendorForm();

  const { register,watch, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: formData.companyProfile || {}, // Initialize with saved data
  });

  const referenceData = useSelector((state) => state.reference);
  const watchedData = watch(); // Watches all fields in the form

  const prevWatchedData = useRef(watchedData); // To track previous form state
  const isFirstSync = useRef(true);

  useEffect(() => {
    // Compare previous and current watched data
    // Skip first sync — resetVendorData already populated context
    if (JSON.stringify(prevWatchedData.current) !== JSON.stringify(watchedData)) {
      if (!isFirstSync.current) {
        updateFormData("companyProfile", watchedData);
      }
      prevWatchedData.current = watchedData;
      isFirstSync.current = false;
    }
  }, [watchedData, updateFormData]);

  const onSubmit = async (formData) => {
      saveVendorData("companyProfile", formData);
      reset(formData); // Reset with current data to clear dirty state
  };

  return (
    <div className="w-full h-full">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-y-6 mt-5 text-sm font-normal text-text-hint">
        <div className="grid grid-cols-4 gap-3">
          <div className="">
            <label className="">Industry</label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border rounded-lg border-neutral-500">
              <input
                {...register("industry", {
                  maxLength: { value: 25, message: "Industry must not exceed 25 characters" }
                })}
                placeholder="Industry"
                maxLength={25}
                className="outline-none w-full text-black"
              />
              <img src={Pencil} alt="pencil" />
            </div>
          </div>
          <div className="">
            <label className="">Year Started</label>
            <input
              {...register("yearStarted", { setValueAs: (value) => value ? parseInt(value, 10) : '', min: { value: 1800, message: "Year must be 1800 or later" }, max: { value: 2100, message: "Year must be 2100 or earlier" } })}
              type="number"
              min={1800}
              max={2100}
              className="outline-none w-full text-black appearance-none flex justify-center items-center px-3 py-2 mt-1 border rounded-lg border-neutral-500"
            />
          </div>
          <div className="">
            <label className="">Number Of Employees</label>
              <input
                {...register("totalEmployees", { setValueAs: (value) => value ? parseInt(value, 10) : '', min: { value: 0, message: "Must be 0 or more" }, max: { value: 9999999, message: "Value too large" } })}
                placeholder="Number of Employees"
                className="outline-none w-full text-black appearance-none flex justify-center items-center px-3 py-2 mt-1 border rounded-lg border-neutral-500"
                type="number"
                min={0}
                max={9999999}
              />
          </div>
        </div>
        <div className="grid grid-cols-4 gap-3">
          <div className="">
            <label className="">DUNS Number</label>
              <input
                {...register("DUNS", { setValueAs: (value) => value ? parseInt(value, 10) : '', maxLength: { value: 9, message: "DUNS must not exceed 9 digits" } })}
                placeholder="DUNS Number"
                className="outline-none w-full text-black appearance-none flex justify-center items-center px-3 py-2 mt-1 border rounded-lg border-neutral-500"
                type="number"
                max={999999999}
              />
          </div>
          <div className="">
            <label className="">NACS Code</label>
              <input
                {...register("NAICS", { setValueAs: (value) => value ? parseInt(value, 10) : '', maxLength: { value: 6, message: "NAICS must not exceed 6 digits" } })}
                placeholder="NACS Code"
                className="outline-none w-full text-black appearance-none flex justify-center items-center px-3 py-2 mt-1 border rounded-lg border-neutral-500"
                type="number"
                max={999999}
              />
          </div>
          <div className="">
            <label className="">Ownership</label>
            <select
              {...register("ownership")}
              className="flex justify-center items-center focus:ring-0 px-3 py-2 mt-1 border rounded-lg outline-none w-full text-black border-neutral-500"
            >
             {mapToOption(referenceData.ownership?.ownership, 'type').map((option) => (
                    <option
                      className=""
                      key={option.value}
                      value={option.value}
                    >
                      {option.text}
                    </option>
                  ))}
            </select>
          </div>
        </div>
      </form>
      <div className="w-full py-10 px-8 flex justify-end items-center gap-2">
        <button
          type="button"
          onClick={() => navigate("/sales/vendors/summary/billing")}
          className="text-secondary-700 border border-secondary-700 py-2 px-5 rounded-full text-base bg-white hover:bg-gray-50 transition"
        >
          Previous
        </button>
        {!isCreating && hasUnsavedChanges && (
          <button
            type="button"
            disabled={isSaving}
            onClick={saveAllChanges}
            className="text-white bg-green-600 py-2 px-5 rounded-full text-base hover:bg-green-700 transition disabled:opacity-50"
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        )}
        <button
          type="button"
          onClick={handleSubmit((data) => {
            updateFormData("companyProfile", data);
            if (isCreating) markTabComplete("company-profile");
            navigate("/sales/vendors/details/company-preference");
          })}
          className="text-white bg-secondary-700 py-2 px-5 rounded-full text-base"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default CompanyProfile;
